const $ = require('jquery'), scrollSize = require('scrollbar-size'), _ = require('lodash');

/**
 * The hidescroll directive hides the scrollbar of a div on which is is applied.
 * It works by wrapping the children of the div in a container which is wider than
 * the parent by the width of the scrollbar, and hiding the overflow of the parent.
 */
module.exports = function HideScroll(breakpointsService) {
    return {
        restrict: 'A',
        controller: [
            '$scope', function ($scope) {
                this.listeners = [];

                this.onScrollStop = function (listener) {
                    this.listeners.push(listener);

                    return _.partial(_.remove, this.listeners, registeredListener => registeredListener === listener);
                };

                this.canScroll = function () {
                    return $scope.canScroll();
                };

                this.scrollBottom = function () {
                    return $scope.scrollBottom();
                };
            },
        ],
        compile(element, attrs) {
            if (attrs.disableHideScrollSf !== undefined && breakpointsService.isInSmallFormat) {
                return function () {};
            }

            const wrapperClass = 'hideScroll-wrapper';
            const wrapper = $(`<div class="${wrapperClass} ${attrs.wowHideScroll || ''}"></div>`);
            wrapper.css({
                width: `calc(100% + ${scrollSize()}px)`,
                height: '100%',
                'overflow-y': 'scroll',
                'overflow-x': 'hidden',
                '-webkit-overflow-scrolling': 'touch',
            });

            element.css({
                overflow: 'hidden',
            });

            element.children().wrapAll(wrapper);

            return function postLink(scope, linkedElement, iAttrs, controller) {
                const wrapperInDom = linkedElement.find(`.${wrapperClass}`);

                function scrollHandler(e) {
                    if (controller.listeners.length) {
                        requestAnimationFrame(() => {
                            const scrollTop = wrapperInDom.scrollTop();
                            const eventData = {
                                scrollTop,
                                scrollBottom: wrapperInDom[0].scrollHeight - wrapperInDom.height() - scrollTop,
                            };

                            _.forEach(controller.listeners, (listener) => {
                                listener(e, eventData);
                            });
                        });
                    }
                }

                wrapperInDom.on('scroll', scrollHandler);

                scope.canScroll = function () {
                    return wrapperInDom[0].scrollHeight > wrapperInDom.height();
                };

                scope.scrollBottom = function () {
                    return wrapperInDom[0].scrollHeight - wrapperInDom.height() - wrapperInDom.scrollTop();
                };
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/hidescroll/hidescroll.directive.js